/* eslint-disable import/no-cycle */
import React from 'react';
import { IoMdClose } from 'react-icons/io';
import { RiErrorWarningFill } from 'react-icons/ri';

import OutlinedButton from 'components/layout/form/outlinedButton';
import ContainedButton from 'components/layout/form/containedButton';

import { Content, Footer, Header, TitleContent } from './styles';

interface ModalConfirmDeleteAddressProps {
  onClickSuccess: () => void;
  onClickFail: () => void;
  loading: boolean;
}

const ModalConfirmDeleteAddress: React.FC<ModalConfirmDeleteAddressProps> = ({
  onClickSuccess,
  onClickFail,
  loading,
}) => {
  return (
    <>
      <Header>
        <IoMdClose onClick={onClickFail} />
      </Header>
      <Content>
        <RiErrorWarningFill />
        <TitleContent>Tem certeza que deseja remover?</TitleContent>
      </Content>
      <Footer>
        <OutlinedButton onClick={onClickFail} disabled={loading}>
          Não, cancelar
        </OutlinedButton>
        <ContainedButton
          onClick={onClickSuccess}
          disabled={loading}
          loading={loading}
        >
          Sim, remover!
        </ContainedButton>
      </Footer>
    </>
  );
};

export default ModalConfirmDeleteAddress;
